/* ============================================================
   Olaben PDP — Tabs (V2 · Option B) + Color Value Bolding
   ============================================================
   1) Builds a sticky vertical tab nav on desktop from the
      details/summary panels rendered by olaben-product-tabs.liquid.
      Mobile keeps native <details> accordion behaviour.

   2) Wraps the selected color value (e.g. "Color: Lava" → "Lava" bold)
      in a <strong> tag, since the theme outputs it as a plain text node.
   ============================================================ */
(function () {
  'use strict';

  var BREAKPOINT = 750;
  function isMobile() {
    return window.matchMedia('(max-width: ' + (BREAKPOINT - 1) + 'px)').matches;
  }

  /* ----------------------------------------------------------
     Icon library — inline SVG, 18x18 stroke-based
     ---------------------------------------------------------- */
  var SVG_DETAIL =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>' +
      '<polyline points="14 2 14 8 20 8"/>' +
      '<line x1="9" y1="13" x2="15" y2="13"/>' +
      '<line x1="9" y1="17" x2="13" y2="17"/>' +
    '</svg>';
  var SVG_FABRIC =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>' +
    '</svg>';
  var SVG_CARE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
      '<line x1="3" y1="7" x2="21" y2="7"/>' +
      '<circle cx="12" cy="14" r="4"/>' +
      '<circle cx="6.5" cy="5" r="0.6" fill="currentColor"/>' +
    '</svg>';
  var SVG_SHIPPING =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M1 6h14v10H1z"/>' +
      '<path d="M15 9h4l3 3v4h-7z"/>' +
      '<circle cx="5.5" cy="18.5" r="1.8"/>' +
      '<circle cx="17.5" cy="18.5" r="1.8"/>' +
    '</svg>';
  var SVG_SIZE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M2 7h20v10H2z"/>' +
      '<line x1="6" y1="7" x2="6" y2="11"/>' +
      '<line x1="10" y1="7" x2="10" y2="11"/>' +
      '<line x1="14" y1="7" x2="14" y2="11"/>' +
      '<line x1="18" y1="7" x2="18" y2="11"/>' +
    '</svg>';
  var SVG_STAR =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>' +
    '</svg>';

  function getTabIcon(label) {
    var lower = (label || '').toLowerCase();
    if (lower.indexOf('detail') !== -1 || lower.indexOf('description') !== -1) return SVG_DETAIL;
    if (lower.indexOf('fabric') !== -1 || lower.indexOf('material') !== -1) return SVG_FABRIC;
    if (lower.indexOf('care') !== -1 || lower.indexOf('wash') !== -1 || lower.indexOf('instruction') !== -1) return SVG_CARE;
    if (lower.indexOf('shipping') !== -1 || lower.indexOf('exchange') !== -1 || lower.indexOf('return') !== -1 || lower.indexOf('delivery') !== -1) return SVG_SHIPPING;
    if (lower.indexOf('size') !== -1 || lower.indexOf('fit') !== -1) return SVG_SIZE;
    return SVG_STAR;
  }

  /* ----------------------------------------------------------
     Tabs initialisation
     ---------------------------------------------------------- */
  function initTabs() {
    var section = document.querySelector('.olaben-tabs-section');
    if (!section) return;

    var navCol = section.querySelector('.olaben-tabs__nav-col');
    if (!navCol) return;

    var panels = section.querySelectorAll('.olaben-tabs__content-col .olaben-tabs__panel');
    if (!panels || panels.length < 2) return;

    if (navCol.querySelector('.olaben-tabs__nav-list')) return; // already initialised

    /* 1. Inject icons into every panel summary (visible on mobile) */
    panels.forEach(function (panel) {
      var heading = panel.getAttribute('data-tab-heading') || '';
      var iconSpan = panel.querySelector('.olaben-tabs__panel-icon');
      if (iconSpan && !iconSpan.innerHTML.trim()) {
        iconSpan.innerHTML = getTabIcon(heading);
      }
    });

    /* 2. Determine default-open tab (prefer detail/description) */
    var defaultIndex = 0;
    panels.forEach(function (panel, i) {
      var heading = (panel.getAttribute('data-tab-heading') || '').toLowerCase();
      if ((heading.indexOf('detail') !== -1 || heading.indexOf('description') !== -1) && defaultIndex === 0) {
        defaultIndex = i;
      }
    });

    /* 3. Build vertical nav for desktop */
    var navList = document.createElement('ul');
    navList.className = 'olaben-tabs__nav-list';
    navList.setAttribute('role', 'tablist');

    panels.forEach(function (panel, i) {
      var heading = panel.getAttribute('data-tab-heading') || 'Tab ' + (i + 1);

      var li = document.createElement('li');
      li.className = 'olaben-tabs__nav-item';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'olaben-tabs__nav-link';
      btn.setAttribute('role', 'tab');
      btn.innerHTML =
        '<span class="olaben-tabs__nav-icon" aria-hidden="true">' + getTabIcon(heading) + '</span>' +
        '<span class="olaben-tabs__nav-label">' + heading + '</span>';

      if (i === defaultIndex) {
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.setAttribute('aria-selected', 'false');
      }

      btn.addEventListener('click', function () {
        if (isMobile()) return;
        navCol.querySelectorAll('.olaben-tabs__nav-link').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.open = false; });
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        panel.open = true;
      });

      li.appendChild(btn);
      navList.appendChild(li);
    });

    navCol.appendChild(navList);

    /* 4. Apply default open/closed state */
    function applyDefaultState() {
      panels.forEach(function (panel, i) {
        panel.open = (i === defaultIndex);
      });
    }
    applyDefaultState();

    /* 5. Re-apply state when crossing breakpoint */
    var wasMobile = isMobile();
    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile !== wasMobile) {
        wasMobile = nowMobile;
        applyDefaultState();
      }
    });
  }

  /* ----------------------------------------------------------
     Bold the selected color value
     ---------------------------------------------------------- */
  function wrapColorValue() {
    var titles = document.querySelectorAll('.product__info-container .title-color');
    titles.forEach(function (el) {
      if (el.querySelector('strong.ola-color-value')) return;
      var html = el.innerHTML;
      var newHtml = html.replace(
        /(Color\s*:|Màu\s*:|Mau\s*:|颜色\s*[:：])\s*(.+?)(\s*<|$)/i,
        '$1 <strong class="ola-color-value">$2</strong>$3'
      );
      if (newHtml !== html) el.innerHTML = newHtml;
    });
  }

  function watchColorChanges() {
    var box = document.querySelector('.product__info-container .color-box');
    if (!box) return;
    var observer = new MutationObserver(function () {
      wrapColorValue();
    });
    observer.observe(box, { childList: true, subtree: true, characterData: true });
  }

  /* ----------------------------------------------------------
     Boot
     ---------------------------------------------------------- */
  function boot() {
    initTabs();
    wrapColorValue();
    watchColorChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ----------------------------------------------------------
     Theme Editor — re-init when sections reload via AJAX
     ---------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector('.olaben-tabs-section') : null;
    if (sec) {
      var existingNav = sec.querySelector('.olaben-tabs__nav-list');
      if (existingNav) existingNav.remove();
    }
    initTabs();
    wrapColorValue();
  });

  document.addEventListener('shopify:section:select', function () {
    initTabs();
  });

  document.addEventListener('shopify:section:reorder', function () {
    initTabs();
  });
})();
